import './bootstrap';

import { createApp } from 'vue';
import { createPinia } from 'pinia';
import FloatingVue from 'floating-vue';
import * as Sentry from "@sentry/vue";
import App from './App.vue';
import router from './router';
import 'floating-vue/dist/style.css';

const pinia = createPinia();
const app = createApp(App);

if (! import.meta.env.DEV) {
    Sentry.init({
        app,
        dsn: import.meta.env.VITE_SENTRY_DSN,
        integrations: [
            Sentry.replayIntegration()
        ],
        // Session Replay
        replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });
}

app.use(router)
    .use(pinia)
    .use(FloatingVue, {
        themes: {
            'menu-tooltip': {
                $extend: 'tooltip',
            },
        },
    })
    .mount('#app');
